import { render } from "./ValidatorManagement.vue?vue&type=template&id=3718dd7d&scoped=true"
import script from "./ValidatorManagement.vue?vue&type=script&lang=js"
export * from "./ValidatorManagement.vue?vue&type=script&lang=js"

import "./ValidatorManagement.vue?vue&type=style&index=0&id=3718dd7d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3718dd7d"]])

export default __exports__